import { UpdateIconButton, pn, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@compass/core";

import { ListBeProperty } from "components";
import { CollegeListDto, CollegeListResource, Permission, PermissionAction, SortObject } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { collegePageRoute } from "../CollegePage/CollegePage";

export const CollegeTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  colleges: CollegeListDto[];
  setColleges: (colleges: CollegeListDto[]) => void;
  resource: CollegeListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  loadList: () => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "7%"}}>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<CollegeListDto>("id"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<CollegeListDto>("name"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<CollegeListDto>("ipeds"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {props.colleges.map((collegeItem) => (
            <TableRow
              key={collegeItem.id}
              onClick={() =>
                navigate(
                  collegePageRoute.getPath({
                    id: collegeItem.id,
                    crudMode: "view",
                    screenType: "dialog"
                  })
                )
              }
            >
              <TableCell>{collegeItem.id}</TableCell>
              <TableCell>{collegeItem.name}</TableCell>
              <TableCell>{collegeItem.ipeds}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton color="primary"
                    onClick={() =>
                      navigate(
                        collegePageRoute.getPath({
                          id: collegeItem.id,
                          crudMode: "edit",
                          screenType: "dialog"
                        })
                      )
                    }
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
